(function (window, $j) {
    $j(document).ready(function () {

        try {
            if (typeof weatherJson == "undefined") {
                return;
            }

            $j.each(weatherJson, function (i, weatherDay) {
                if (weatherDay.DaySequence === 1) {
                    $j('#dayOneName').text(weatherDay.DayOfWeek);
                    $j('#dayOneHighTemp').html(weatherDay.HighTemperature + "&deg;");
                    $j('#dayOneLowTemp').html(weatherDay.LowTemperature + "&deg;");
                    $j('#dayOneIcon').attr("src", weatherDay.IconUrl);
                    $j('#dayOneIcon').attr("alt", weatherDay.IconName);
                }
                if (weatherDay.DaySequence === 2) {
                    $j('#dayTwoName').text(weatherDay.DayOfWeek);
                    $j('#dayTwoHighTemp').html(weatherDay.HighTemperature + "&deg;");
                    $j('#dayTwoLowTemp').html(weatherDay.LowTemperature + "&deg;");
                    $j('#dayTwoIcon').attr("src", weatherDay.IconUrl);
                    $j('#dayTwoIcon').attr("alt", weatherDay.IconName);
                }
                if (weatherDay.DaySequence === 3) {
                    $j('#dayThreeName').text(weatherDay.DayOfWeek);
                    $j('#dayThreeHighTemp').html(weatherDay.HighTemperature + "&deg;");
                    $j('#dayThreeLowTemp').html(weatherDay.LowTemperature + "&deg;");
                    $j('#dayThreeIcon').attr("src", weatherDay.IconUrl);
                    $j('#dayThreeIcon').attr("alt", weatherDay.IconName);
                }
                if (weatherDay.DaySequence === 4) {
                    $j('#dayFourName').text(weatherDay.DayOfWeek);
                    $j('#dayFourHighTemp').html(weatherDay.HighTemperature + "&deg;");
                    $j('#dayFourLowTemp').html(weatherDay.LowTemperature + "&deg;");
                    $j('#dayFourIcon').attr("src", weatherDay.IconUrl);
                    $j('#dayFourIcon').attr("alt", weatherDay.IconName);
                }
            });
        } catch (e) { }



    });
})(window, $j);
